import type { ApiClient } from '@travel/api-client';

import { MONTEROSA_API_TIMEOUT } from 'store/utils';

import type { RequestBody, VacancyCalendarResponse } from 'VacancyCalendar-Types';

export const fetchVacancyCalendarDates = (
  http: ApiClient,
  query: RequestBody,
): Promise<VacancyCalendarResponse> =>
  http.post(`/monterosa-api-dp/dp/jrdp/plan-item-calendar`, {
    values: query,
    timeout: MONTEROSA_API_TIMEOUT,
    ignoreCommonErrorHandler: true,
  });
